import { createSlice } from "@reduxjs/toolkit";

export const modalSlice = createSlice({
  name: "modal",
  initialState: {
    value: {
      view: false,
      title: "Not accepting responses",
      caption:
        "We’re not accepting responses at this time, please check back later.",
    },
  },

  reducers: {
    openModal: (state, action) => {
      const modalProps = action.payload;
      state.value.view = true;
      state.value.title = modalProps.title;
      state.value.caption = modalProps.caption;
    },
    closeModal: (state) => {
      state.value.view = false;
      state.value.title = null;
      state.value.caption = null;
    },
    assistantApplicationsClosed: (state, action) => {
      /*eslint no-unused-vars: 2*/
      modalSlice.caseReducers.openModal(state, action = {
        payload: {
          title: 'Not accepting responses',
          caption: 'We’re not accepting assistant applications at this time, please check back later.'
        }
      })
      console.log(action)
    },
  },
});

export const { openModal, closeModal, assistantApplicationsClosed } =
  modalSlice.actions;

export default modalSlice.reducer;
